import { render, staticRenderFns } from "./EditSurvey.vue?vue&type=template&id=95b3b542&scoped=true&"
import script from "./EditSurvey.vue?vue&type=script&lang=js&"
export * from "./EditSurvey.vue?vue&type=script&lang=js&"
import style0 from "./EditSurvey.vue?vue&type=style&index=0&id=95b3b542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b3b542",
  null
  
)

export default component.exports